import styled from 'styled-components'
import ReactDatepicker from 'react-datepicker'

import colors from '../../styles/colors'

const DatePicker = styled(ReactDatepicker)`
  width: ${(props) => props.width}px;
  border: 1px solid ${colors.light_black};
  font-size: 14px;
  padding: 10px 15px;
  border-radius: 4px;
  height: 50px;
  box-sizing: border-box;
  font-size: 12px;
  display: flex;
  flex-grow: 1;
  align-items: center;
  height: 50px;
  border-radius: 4px;
  padding: 2px 10px 0;
  color: ${colors.light_black};
  width: ${(props) => props.width}px;
  ${(props) => props.error && `border: 1px solid ${colors.monza}`};
  ${(props) => props.readOnly && `background: ${colors.readOnly}`};
`

export default DatePicker
